export const filterOptions = [
  { name: "Depot", value: "depot" },
  { name: "Customer ID", value: "customerId" },
  { name: "TSR", value: "technician" },
];

export const validFilters = ["depot", "customerId", "technician"];

export const STATUSES = ["Pending", "In Progress", "Completed", "Rejected"];
